import { Api } from "@quipa/api";
import { actionReducer } from "../../utils";
import { defaults, State } from "./model";

export default actionReducer<Api.RealtimeActionsMap, State>(defaults(), {
});
